import { render, staticRenderFns } from "./BookingsOld.vue?vue&type=template&id=09b72062&"
import script from "./BookingsOld.vue?vue&type=script&lang=js&"
export * from "./BookingsOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VContainer,VDatePicker})
